/*
  sp-garde — retire le geste facile d'enregistrement des images (demande de l'artiste, 11/10/2026).

  Sur les images du contenu (#MainContent : œuvres, mises en situation, galerie) et du zoom
  de la fiche (product-modal, placé hors de #MainContent) :
  pas de menu « Enregistrer l'image » au clic droit, pas de glisser-déposer vers le bureau.
  L'appui long sur mobile est neutralisé côté CSS (sp-finition.css, -webkit-touch-callout).

  Ce n'est pas une protection : une capture d'écran ou les outils du navigateur passent
  outre. Le but est seulement d'ôter le geste à portée de main. Le reste de la page (texte,
  liens, champs) garde son menu contextuel normal ; le clavier n'est pas touché.
*/
(function () {
  function surImageDuContenu(e) {
    var t = e.target;
    return t && t.tagName === 'IMG' && t.closest && t.closest('#MainContent, product-modal, .product-media-modal');
  }
  document.addEventListener('contextmenu', function (e) {
    if (surImageDuContenu(e)) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    if (surImageDuContenu(e)) e.preventDefault();
  });
})();
